import React, { useState, useEffect } from "react";
import CustomTable from "../organisms/CustomTable";
import SearchBar from "../atoms/SearchButton";
import { getHistoryDetails } from "../../utils/API/getHistoryDetails.js";
import { useSearchParams } from "react-router-dom";
import Pagination from "../atoms/Pagination";
import { Skeleton } from "antd";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";

const headerData = ["History", "Date", "Time"];

const getMonth = {
  1: "Jan",
  2: "Feb",
  3: "Mar",
  4: "Apr",
  5: "May",
  6: "Jun",
  7: "Jul",
  8: "Aug",
  9: "Sep",
  10: "Oct",
  11: "Nov",
  12: "Dec",
};

const HistoryPage = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [searchItem, setSearchItem] = useState("");

  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = Number(searchParams.get("page")) || 1;

  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    totalItems: 0,
    totalPages: 0,
  });

  const pageSize = 10;

  const handleSearch = (searchTerm) => {};

  // const formatDate = (dateString) => {
  //   const date = new Date(dateString);
  
  //   const day = String(date.getDate()).padStart(2, '0');
  //   const month = date.toLocaleString('default', { month: 'short' });
  //   const year = date.getFullYear();
  
  //   const formattedDate = ${day}-${month}-${year};
  
  
  
  //   const formattedTime = ${hours}:${minutes}:${seconds};
  
  //   return { formattedDate, formattedTime };
  // };
  
  // export default formatDate

  useEffect(() => {
    const fetchProjectData = async () => {
      setIsLoading(true);
      try {
        const { notificationsHistoryList, metaData } = await getHistoryDetails(
          {
            currentPage,
            pagelimit: 10,
          },
          dispatch
        );
        const transformedData = notificationsHistoryList.map(
          ({ content, createdAt }) => {
            
            const date = new Date(createdAt);
            // console.log(date)
            const dd = String(date.getDate()).padStart(2, "0");
            const mm = date.toLocaleString('default', { month: 'short' });
            const yy = date.getFullYear();

            const time = date.toLocaleTimeString("en-US", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            });
            return [
              <div className=" pl-4 w-full text-left text-xs font-normal">{content}</div>,
              <div className="text-[#808080] text-xs">{`${dd} ${mm} ${yy}`}</div>,
              <div className="text-[#808080] text-xs">{time}</div>,
            ];
          }
        );
        setData(transformedData);
        setPagination({
          totalItems: metaData.totalCount,
          totalPages: metaData.totalPages,
          pageSize: metaData.pageSize,
        });
      } catch (error) {
        toast.error("Something went wrong!");
      } finally {
        setIsLoading(false);
      }
    };
    fetchProjectData();
  }, [currentPage]);

  return (
    <>
      <div className="bg-gray-100 min-h-screen w-full p-6 relative flex flex-col">
        <h3 className="text-2xl font-bold pb-4">History</h3>
        <div className="bg-white h-screen rounded-2xl pb-4 px-2 no-scrollbar flex flex-col overflow-auto">
          <div className="flex-grow">
            <div className="flex justify-between py-4 pr-6">
              <div className="w-80 border-2 border-grey-800 rounded-lg mx-5 mb-4">
                <SearchBar
                  onSearch={handleSearch}
                  searchItem={searchItem}
                  setSearchItem={setSearchItem}
                  variant="secondaryxl"
                  className="text-black"
                  borderColor="border-none"
                  placeholderColor="black"
                  inputBackground="white"
                  svgStrokeColor="black"
                  inputWidth="72"
                  inputHeight="8"
                />
              </div>
            </div>

            <div className="flex flex-col gap-y-4 p-4 flex-grow">
              <CustomTable
                data={isLoading ? [] : data}
                headerData={headerData}
              />
              {isLoading && (
                <div className="flex flex-col gap-y-4 p-4">
                  <Skeleton.Button block={true} active={true} />
                  <Skeleton.Button block={true} active={true} />
                  <Skeleton.Button block={true} active={true} />
                  <Skeleton.Button block={true} active={true} />
                </div>
              )}
            </div>
          </div>
          {pagination.totalPages > 1 && (
            <Pagination
              current={currentPage}
              total={pagination.totalItems}
              pageSize={pageSize}
              setCurrentPage={(page) => setSearchParams({ page })}
              style={{
                marginTop: "auto",
              }}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default HistoryPage;
